import { UPDATE_THEME, ThemeAction, ThemeState } from './Theme.types'

export const ThemeReducer = (
  state: ThemeState,
  action: ThemeAction
): ThemeState => {
  switch (action.type) {
    case UPDATE_THEME:
      return {
        ...state,
        theme: action.payload,
      }
    default:
      return state
  }
}
